import React, { useState } from 'react';
import { Typography, Row, Col, Card, Form, Input, Select, Button, Space } from 'antd';
import {
    PhoneOutlined,
    MailOutlined,
    EnvironmentOutlined,
    ClockCircleOutlined,
    SendOutlined,
} from '@ant-design/icons';
import { toast } from 'react-toastify';
import './Contact.scss';

const { Title, Paragraph, Text } = Typography;
const { TextArea } = Input;

const agences = [
    {
        nom: 'Agence 2 Plateaux Vallon',
        adresse: 'Abidjan, 2 Plateaux Vallon',
        telephone: '+225 07 00 00 00 00',
        email: 'vallon@capassurances-sc.net',
        horaires: 'Lun - Ven : 8h00 - 17h30',
    },
    {
        nom: 'Agence Riviera Golf',
        adresse: 'Abidjan, Riviera Golf',
        telephone: '+225 07 00 00 00 01',
        email: 'riviera@capassurances-sc.net',
        horaires: 'Lun - Ven : 8h00 - 17h30',
    },
];

export default function Contact() {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (values) => {
        setLoading(true);
        try {
            // Simuler l'envoi du formulaire
            await new Promise(resolve => setTimeout(resolve, 1500));
            toast.success('Votre message a ete envoye avec succes. Nous vous recontacterons rapidement.');
            form.resetFields();
        } catch {
            toast.error('Erreur lors de l\'envoi du message. Veuillez reessayer.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-contact">
            <section className="contact-hero">
                <Title level={1} className="hero-title">Contactez-nous</Title>
                <Paragraph className="hero-subtitle">
                    Notre equipe est a votre disposition pour repondre a vos questions
                    et vous accompagner dans vos projets d'assurance
                </Paragraph>
            </section>

            <section className="section">
                <div className="section-inner">
                    <Row gutter={[48, 48]}>
                        {/* Formulaire */}
                        <Col xs={24} lg={14}>
                            <Title level={3}>Envoyez-nous un message</Title>
                            <div className="section-line left" />

                            <Card className="contact-form-card" bordered={false}>
                                <Form
                                    form={form}
                                    layout="vertical"
                                    onFinish={handleSubmit}
                                    size="large"
                                >
                                    <Row gutter={16}>
                                        <Col xs={24} sm={12}>
                                            <Form.Item
                                                name="nom"
                                                label="Nom complet"
                                                rules={[{ required: true, message: 'Veuillez saisir votre nom' }]}
                                            >
                                                <Input placeholder="Votre nom et prenom" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={12}>
                                            <Form.Item
                                                name="telephone"
                                                label="Telephone"
                                                rules={[{ required: true, message: 'Veuillez saisir votre telephone' }]}
                                            >
                                                <Input placeholder="+225 07 XX XX XX XX" />
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                    <Form.Item name="email" label="Email">
                                        <Input placeholder="votre@email.com" />
                                    </Form.Item>

                                    <Form.Item name="sujet" label="Sujet" rules={[{ required: true, message: 'Veuillez choisir un sujet' }]}>
                                        <Select placeholder="Selectionnez un sujet">
                                            <Select.Option value="devis">Demande de devis</Select.Option>
                                            <Select.Option value="info">Demande d'information</Select.Option>
                                            <Select.Option value="sinistre">Declaration de sinistre</Select.Option>
                                            <Select.Option value="reclamation">Reclamation</Select.Option>
                                            <Select.Option value="autre">Autre</Select.Option>
                                        </Select>
                                    </Form.Item>

                                    <Form.Item
                                        name="message"
                                        label="Message"
                                        rules={[{ required: true, message: 'Veuillez saisir votre message' }]}
                                    >
                                        <TextArea rows={5} placeholder="Decrivez votre demande..." />
                                    </Form.Item>

                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        loading={loading}
                                        icon={<SendOutlined />}
                                        block
                                    >
                                        Envoyer le message
                                    </Button>
                                </Form>
                            </Card>
                        </Col>

                        {/* Infos contact */}
                        <Col xs={24} lg={10}>
                            <Title level={3}>Nos agences</Title>
                            <div className="section-line left" />

                            <Space direction="vertical" size={24} style={{ width: '100%' }}>
                                {agences.map((agence, i) => (
                                    <Card key={i} className="agence-card" bordered>
                                        <Title level={5} style={{ marginBottom: 16 }}>{agence.nom}</Title>
                                        <Space direction="vertical" size={10}>
                                            <div className="contact-info-item">
                                                <EnvironmentOutlined />
                                                <Text>{agence.adresse}</Text>
                                            </div>
                                            <div className="contact-info-item">
                                                <PhoneOutlined />
                                                <Text>{agence.telephone}</Text>
                                            </div>
                                            <div className="contact-info-item">
                                                <MailOutlined />
                                                <Text>{agence.email}</Text>
                                            </div>
                                            <div className="contact-info-item">
                                                <ClockCircleOutlined />
                                                <Text>{agence.horaires}</Text>
                                            </div>
                                        </Space>
                                    </Card>
                                ))}
                            </Space>
                        </Col>
                    </Row>
                </div>
            </section>
        </div>
    );
}
